(function () {
    'use strict';

    angular.module('app.common')
        .factory('mapOptionsService', ['$translate', mapOptionsService]);

    function mapOptionsService($translate) {
        var obj = {
            drawLayer: null,
            tempLayer: null,
            getDefaultOptions: getDefaultOptions,
            getDefaultOptionsSimple: getDefaultOptionsSimple,
            getOptions: getOptions,
            getOptionsRealEstate: getOptionsRealEstate,
            getOptionsPlatinum: getOptionsPlatinum,
            getOptionsPremium: getOptionsPremium,

            getOptionsLocation: getOptionsLocation,
            getOptionsWidget: getOptionsWidget,
            getOptionsAgent: getOptionsAgent,
            getMapOptionsNeighbors: getMapOptionsNeighbors,
            getLandingOptions: getLandingOptions,
            getOptionsQuake: getOptionsQuake,
            getMarker: getMarker,
            getDraw: drawControl,
            getOpportunityOptions: getOpportunityOptions,
            mapBoxToken: 'pk.eyJ1IjoiZW5kZWtzYSIsImEiOiJja21kdWZvcjMxdXk2MnBwaGVneHJjeXB3In0.jsYPQYIVhGIYF4AXFS5O7A'
        };

        var r2x = "@2x";

        if (!window.isHighDensity() && !window.isRetina()) {
            r2x = "";
        }

        return obj;

        function getLandingOptions() {
            return {
                defaults: {
                    zoomControlPosition: false,
                    attributionControl: false,
                    zoomControl: false,
                    zoom: 3,
                    scrollWheelZoom: false
                },
                layers: {
                    baselayers: {},
                    overlays: {
                        markers: {
                            name: 'Markers',
                            type: 'group',
                            visible: true,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        }
                    }
                }
            };
        }

        function getOpportunityOptions(position) {
            return {
                detaildefaults: {
                    zoomControlPosition: position ? position : 'topleft',
                    attributionControl: false,
                    zoomControl: position === 'hide' ? false : true,
                    zoom: 7
                },
                detaillayers: {
                    baselayers: {
                        google_satellite: {
                            name: $translate.instant('c_map1'),
                            url: 'https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map34'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true
                            }
                        },
                        mapbox: {
                            name: $translate.instant('c_map2'),
                            type: 'xyz',
                            url: 'https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                light: true
                            }
                        }
                    }
                }
            };
        }

        function getDefaultOptions(position) {
            return {
                detaildefaults: {
                    zoomControlPosition: position ? position : 'topleft',
                    attributionControl: false,
                    zoomControl: position === 'hide' ? false : true,
                    zoom: 19
                },
                detaillayers: {
                    baselayers: {
                        google_satellite: {
                            name: $translate.instant('c_map1'),
                            url: 'https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map34'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true
                            }
                        },
                        mapbox_satellite: {
                            name: $translate.instant('c_map3'),
                            url: 'https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3
                            }
                        }
                    },
                    overlays: {
                        // opportunities: {
                        //     name: $translate.instant('c_map10'),
                        //     type: 'markercluster',
                        //     visible: true,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     }
                        // },
                        // agents: {
                        //     name: $translate.instant('c_map9'),
                        //     type: 'markercluster',
                        //     visible: true,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     }
                        // }
                    }
                }
            };
        }


        function getDefaultOptionsSimple(position) {
            return {
                detaildefaults: {
                    zoomControlPosition: position ? position : 'topleft',
                    attributionControl: false,
                    zoomControl: position === 'hide' ? false : true,
                    zoom: 19
                },
                detaillayers: {
                    baselayers: {
                        google_satellite: {
                            name: $translate.instant('c_map1'),
                            url: 'https://{s}.google.com/vt/lyrs=s@189&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map34'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true
                            }
                        },
                        // mapbox_satellite: {
                        //     name: $translate.instant('c_map3'),
                        //     url: 'https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                        //     type: 'xyz',
                        //     layerOptions: {
                        //         attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                        //         continuousWorld: true,
                        //         maxZoom: 22,
                        //         minZoom: 3
                        //     }
                        // }
                    },
                    overlays: {

                        // opportunities: {
                        //     name: $translate.instant('c_map10'),
                        //     type: 'markercluster',
                        //     visible: true,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     }
                        // },
                        // agents: {
                        //     name: $translate.instant('c_map9'),
                        //     type: 'markercluster',
                        //     visible: true,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     }
                        // },
                        // quakes: {
                        //     name: $translate.instant('c_map8'),
                        //     type: 'markercluster',
                        //     visible: true,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     }
                        // }
                    }
                }
            };
        }



        function getOptions() {
            return {
                defaults: {
                    zoomControlPosition: 'topleft',
                    attributionControl: true,
                    zoom: 9
                },
                layercontrol: {
                    order: false,
                    // icons: {
                    //     uncheck: "fa ei-toggle-off",
                    //     check: "fa ei-toggle-on"
                    // }
                },
                detaillayers: {
                    baselayers: {
                        google: {
                            name: 'Google',
                            url: 'https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map29'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        google_satellite: {
                            name: $translate.instant('c_map1'),
                            url: 'https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map34'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true
                            },
                            group: $translate.instant('c_map4')
                        },
                        mapbox_satellite: {
                            name: $translate.instant('c_map3'),
                            url: 'https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3
                            }
                        },
                        mapbox: {
                            name: $translate.instant('c_map2'),
                            type: 'xyz',
                            url: 'https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        mapbox_terrain: {
                            name: $translate.instant('c_map15'),
                            type: 'xyz',
                            url: 'https://api.mapbox.com/styles/v1/mapbox/outdoors-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        //pencil: {
                        //    name: window.lang === 'tr' ? 'Kara Kalem' : 'Pencil',
                        //    type: 'xyz',
                        //    visible: true,
                        //    url: 'https://api.mapbox.com/v4/mapbox.pencil/{z}/{x}/{y}' + r2x + '.png?access_token=' + obj.mapBoxToken,
                        //    layerOptions: {
                        //        attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                        //        continuousWorld: true,
                        //        maxZoom: 22,
                        //        minZoom: 3
                        //    },
                        //    group: $translate.instant('c_map5')
                        //},
                        //streeta: {
                        //    name: window.lang === 'tr' ? 'Açık Ton' : 'Light',
                        //    type: 'xyz',
                        //    visible: true,
                        //    url: 'https://api.mapbox.com/v4/mapbox.light/{z}/{x}/{y}' + r2x + '.png?access_token=' + obj.mapBoxToken,
                        //    layerOptions: {
                        //        attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                        //        continuousWorld: true,
                        //        maxZoom: 22,
                        //        minZoom: 3
                        //    },
                        //    group: $translate.instant('c_map5')
                        //},
                        mapbox_dark: {
                            name: $translate.instant('c_map6'),
                            type: 'xyz',
                            visible: true,
                            url: 'https://api.mapbox.com/styles/v1/mapbox/dark-v10/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3
                            },
                            group: $translate.instant('c_map5')
                        },
                        //pastel: {
                        //    name: 'Pastel',
                        //    type: 'xyz',
                        //    visible: true,
                        //    url: 'https://api.mapbox.com/v4/mapbox.wheatpaste/{z}/{x}/{y}' + r2x + '.png?access_token=' + obj.mapBoxToken,
                        //    layerOptions: {
                        //        attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                        //        continuousWorld: true,
                        //        maxZoom: 22,
                        //        minZoom: 3
                        //    },
                        //    group: $translate.instant('c_map5')
                        //},

                        //yandex: {
                        //    name: 'Yandex',
                        //    type: 'yandex',
                        //    layerOptions: {
                        //        attribution: "&copy; Yandex",
                        //        layerType: 'map'
                        //    }
                        //}

                    },
                    overlays: {
                        draw: {
                            name: $translate.instant('c_map35'),
                            type: 'group',
                            visible: true,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        },
                        places: {
                            name: 'POI',
                            type: 'markerscanvas',
                            visible: true,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,

                            }
                        },
                        heatmap: {
                            name: $translate.instant('c_map7'),
                            type: 'group',
                            visible: true,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                maxZoom: 22,
                                minZoom: 9,
                                showOnSelector: false
                            }
                        },
                        malls: {
                            name: $translate.instant('c_map20'),
                            type: 'markercluster',
                            visible: false,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        },
                        projects: {
                            name: $translate.instant('c_map21'),
                            type: 'markercluster',
                            visible: false,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        },
                        opportunities: {
                            name: $translate.instant('c_map10'),
                            type: 'markercluster',
                            visible: true,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        },
                        agents: {
                            name: $translate.instant('c_map9'),
                            type: 'markercluster',
                            visible: true,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        },
                        portfolio: {
                            name: $translate.instant('c_map11'),
                            type: 'markercluster',
                            visible: true,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        }
                        // megaProjects: {
                        //     name: window.lang === 'tr' ? 'Mega Projeler' : 'Mega Projects',
                        //     type: 'group',
                        //     visible: false,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     }
                        // },
                    }
                }
            };
        }

        function getOptionsPremium() {
            return {
                defaults: {
                    zoomControlPosition: 'topleft',
                    attributionControl: true,
                    zoom: 9
                },
                layercontrol: {
                    order: false,
                    // icons: {
                    //     uncheck: "fa ei-toggle-off",
                    //     check: "fa ei-toggle-on"
                    // }
                },
                detaillayers: {
                    baselayers: {
                        google: {
                            name: 'Google',
                            url: 'https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map29'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        google_satellite: {
                            name: $translate.instant('c_map1'),
                            url: 'https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map34'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true
                            },
                            group: $translate.instant('c_map4')
                        },
                        mapbox_satellite: {
                            name: $translate.instant('c_map3'),
                            url: 'https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3
                            }
                        },
                        mapbox: {
                            name: $translate.instant('c_map2'),
                            type: 'xyz',
                            url: 'https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,

                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        mapbox_terrain: {
                            name: $translate.instant('c_map15'),
                            type: 'xyz',
                            url: 'https://api.mapbox.com/styles/v1/mapbox/outdoors-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,

                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        //pencil: {
                        //    name: window.lang === 'tr' ? 'Kara Kalem' : 'Pencil',
                        //    type: 'xyz',
                        //    visible: true,
                        //    url: 'https://api.mapbox.com/v4/mapbox.pencil/{z}/{x}/{y}' + r2x + '.png?access_token=' + obj.mapBoxToken,
                        //    layerOptions: {
                        //        attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                        //        continuousWorld: true,
                        //        maxZoom: 22,
                        //        minZoom: 3
                        //    },
                        //    group: $translate.instant('c_map5')
                        //},
                        //streeta: {
                        //    name: window.lang === 'tr' ? 'Açık Ton' : 'Light',
                        //    type: 'xyz',
                        //    visible: true,
                        //    url: 'https://api.mapbox.com/v4/mapbox.light/{z}/{x}/{y}' + r2x + '.png?access_token=' + obj.mapBoxToken,
                        //    layerOptions: {
                        //        attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                        //        continuousWorld: true,
                        //        maxZoom: 22,
                        //        minZoom: 3
                        //    },
                        //    group: $translate.instant('c_map5')
                        //},
                        mapbox_dark: {
                            name: $translate.instant('c_map6'),
                            type: 'xyz',
                            visible: true,
                            url: 'https://api.mapbox.com/styles/v1/mapbox/dark-v10/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3
                            },
                            group: $translate.instant('c_map5')
                        },
                        //pastel: {
                        //    name: 'Pastel',
                        //    type: 'xyz',
                        //    visible: true,
                        //    url: 'https://api.mapbox.com/v4/mapbox.wheatpaste/{z}/{x}/{y}' + r2x + '.png?access_token=' + obj.mapBoxToken,
                        //    layerOptions: {
                        //        attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                        //        continuousWorld: true,
                        //        maxZoom: 22,
                        //        minZoom: 3
                        //    },
                        //    group: $translate.instant('c_map5')
                        //},

                        //yandex: {
                        //    name: 'Yandex',
                        //    type: 'yandex',
                        //    layerOptions: {
                        //        attribution: "&copy; Yandex",
                        //        layerType: 'map'
                        //    }
                        //}

                    },
                    overlays: {
                        draw: {
                            name: $translate.instant('c_map35'),
                            type: 'group',
                            visible: true,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        },
                        places: {
                            name: 'POI',
                            type: 'markerscanvas',
                            visible: true,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,

                            }
                        },
                        heatmap: {
                            name: $translate.instant('c_map7'),
                            type: 'group',
                            visible: true,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                maxZoom: 22,
                                minZoom: 9,
                                showOnSelector: false
                            }
                        },
                        // malls: {
                        //     name: $translate.instant('c_map20'),
                        //     type: 'markercluster',
                        //     visible: false,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     }
                        // },
                        // projects: {
                        //     name: $translate.instant('c_map21'),
                        //     type: 'markercluster',
                        //     visible: false,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     }
                        // },
                        opportunities: {
                            name: $translate.instant('c_map10'),
                            type: 'markercluster',
                            visible: true,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        },
                        agents: {
                            name: $translate.instant('c_map9'),
                            type: 'markercluster',
                            visible: false,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        },
                        portfolio: {
                            name: $translate.instant('c_map11'),
                            type: 'markercluster',
                            visible: true,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        }
                        // megaProjects: {
                        //     name: window.lang === 'tr' ? 'Mega Projeler' : 'Mega Projects',
                        //     type: 'group',
                        //     visible: false,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     }
                        // },
                    }
                }
            };
        }

        function getOptionsRealEstate() {
            return {
                defaults: {
                    zoomControlPosition: 'topleft',
                    attributionControl: true,
                    zoom: 9
                },
                layercontrol: {
                    order: false,
                    // icons: {
                    //     uncheck: "fa ei-toggle-off",
                    //     check: "fa ei-toggle-on"
                    // }
                },
                detaillayers: {
                    baselayers: {
                        google: {
                            name: 'Google',
                            url: 'https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map29'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        google_satellite: {
                            name: $translate.instant('c_map1'),
                            url: 'https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map34'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true
                            },
                            group: $translate.instant('c_map4')
                        },
                        mapbox_satellite: {
                            name: $translate.instant('c_map3'),
                            url: 'https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3
                            }
                        },
                        mapbox: {
                            name: $translate.instant('c_map2'),
                            type: 'xyz',
                            url: 'https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        mapbox_terrain: {
                            name: $translate.instant('c_map15'),
                            type: 'xyz',
                            url: 'https://api.mapbox.com/styles/v1/mapbox/outdoors-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,

                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        mapbox_dark: {
                            name: $translate.instant('c_map6'),
                            type: 'xyz',
                            visible: true,
                            url: 'https://api.mapbox.com/styles/v1/mapbox/dark-v10/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3
                            },
                            group: $translate.instant('c_map5')
                        },

                    },
                    overlays: {
                        // Descending sort: higher index = appears first (top)
                        // Order: Ungrouped (900+) → Ticari (700s) → Konut (500s) → WMS (200s) → Diğer (100s)

                        // Grupsuz layer'lar (index: 900+) - en üstte
                        places: {
                            name: 'POI',
                            type: 'markerscanvas',
                            visible: true,
                            index: 999,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,

                            }
                        },
                        draw: {
                            name: $translate.instant('c_map35'),
                            type: 'group',
                            visible: true,
                            index: 998,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        },
                        heatmap: {
                            name: $translate.instant('c_map7'),
                            type: 'group',
                            visible: true,
                            index: 997,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                maxZoom: 22,
                                minZoom: 9,
                                showOnSelector: false
                            }
                        },

                        // Ticari grubu (index: 700-799)
                        commercialRentStore: {
                            name: $translate.instant('c_map23'),
                            type: 'group',
                            visible: false,
                            index: 706,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },

                        commercialPriceStore: {
                            name: $translate.instant('c_map24'),
                            type: 'group',
                            visible: false,
                            index: 705,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },
                        commercialRentOffice: {
                            name: $translate.instant('c_map25'),
                            type: 'group',
                            visible: false,
                            index: 704,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },
                        commercialPriceOffice: {
                            name: $translate.instant('c_map26'),
                            type: 'group',
                            visible: false,
                            index: 703,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },

                        // Konut grubu (index: 500-599)
                        salesCount: {
                            name: $translate.instant('c_map32'),
                            type: 'group',
                            visible: false,
                            index: 507,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propSalePrice: {
                            name: $translate.instant('c_map27'),
                            type: 'group',
                            visible: false,
                            index: 506,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propRentPrice: {
                            name: $translate.instant('c_map28'),
                            type: 'group',
                            visible: false,
                            index: 505,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propRoom: {
                            name: $translate.instant('c_map17'),
                            type: 'group',
                            visible: false,
                            index: 504,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propArea: {
                            name: $translate.instant('c_map16'),
                            type: 'group',
                            visible: false,
                            index: 503,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propFloor: {
                            name: $translate.instant('c_map18'),
                            type: 'group',
                            visible: false,
                            index: 502,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propAge: {
                            name: $translate.instant('c_map19'),
                            type: 'group',
                            visible: false,
                            index: 501,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },

                        // Diğer grubu (index: 100-199) - en altta (WMS'den sonra)
                        malls: {
                            name: $translate.instant('c_map20'),
                            type: 'markercluster',
                            visible: false,
                            index: 105,
                            layerOptions: {
                                showCoverageOnHover: false
                            },
                            group: $translate.instant('c_map12')
                        },
                        projects: {
                            name: $translate.instant('c_map21'),
                            type: 'markercluster',
                            visible: false,
                            index: 104,
                            layerOptions: {
                                showCoverageOnHover: false
                            },
                            group: $translate.instant('c_map12')
                        },
                        opportunities: {
                            name: $translate.instant('c_map10'),
                            type: 'markercluster',
                            visible: true,
                            index: 103,
                            layerOptions: {
                                showCoverageOnHover: false
                            },
                            group: $translate.instant('c_map12')
                        },
                        agents: {
                            name: $translate.instant('c_map9'),
                            type: 'markercluster',
                            visible: false,
                            index: 102,
                            layerOptions: {
                                showCoverageOnHover: false
                            },
                            group: $translate.instant('c_map12')
                        },
                        portfolio: {
                            name: $translate.instant('c_map11'),
                            type: 'markercluster',
                            visible: true,
                            index: 101,
                            layerOptions: {
                                showCoverageOnHover: false
                            },
                            group: $translate.instant('c_map12')
                        },
                        // megaProjects: {
                        //     name: window.lang === 'tr' ? 'Mega Projeler' : 'Mega Projects',
                        //     type: 'group',
                        //     visible: false,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     },
                        //     group: $translate.instant('c_map12')
                        // },
                    }
                }
            };
        }


        function getOptionsPlatinum() {
            return {
                defaults: {
                    zoomControlPosition: 'topleft',
                    attributionControl: true,
                    zoom: 9
                },
                layercontrol: {
                    order: false,
                    // icons: {
                    //     uncheck: "fa ei-toggle-off",
                    //     check: "fa ei-toggle-on"
                    // }
                },
                detaillayers: {
                    baselayers: {
                        google: {
                            name: 'Google',
                            url: 'https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map29'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        google_satellite: {
                            name: $translate.instant('c_map1'),
                            url: 'https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map34'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true
                            },
                            group: $translate.instant('c_map4')
                        },
                        mapbox_satellite: {
                            name: $translate.instant('c_map3'),
                            url: 'https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3
                            }
                        },
                        mapbox: {
                            name: $translate.instant('c_map2'),
                            type: 'xyz',
                            url: 'https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,

                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        mapbox_terrain: {
                            name: $translate.instant('c_map15'),
                            type: 'xyz',
                            url: 'https://api.mapbox.com/styles/v1/mapbox/outdoors-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,

                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        mapbox_dark: {
                            name: $translate.instant('c_map6'),
                            type: 'xyz',
                            visible: true,
                            url: 'https://api.mapbox.com/styles/v1/mapbox/dark-v10/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3
                            },
                            group: $translate.instant('c_map5')
                        }
                    },
                    overlays: {
                        // Descending sort: higher index = appears first (top)
                        // Order: Ungrouped (900+) → Ticari (700s) → Konut (500s) → WMS (200s) → Diğer (100s)

                        // Grupsuz layer'lar (index: 900+) - en üstte
                        places: {
                            name: 'POI',
                            type: 'markerscanvas',
                            visible: true,
                            index: 999,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,

                            }
                        },
                        draw: {
                            name: $translate.instant('c_map35'),
                            type: 'group',
                            visible: true,
                            index: 998,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        },
                        heatmap: {
                            name: $translate.instant('c_map7'),
                            type: 'group',
                            visible: true,
                            index: 997,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                maxZoom: 22,
                                minZoom: 9,
                                showOnSelector: false
                            }
                        },

                        traffic: {
                            name: $translate.instant('c_map30'),
                            url: 'https://api.tomtom.com/traffic/map/4/tile/flow/absolute/{z}/{x}/{y}.png?key=xHAk40RiUkJsPXwXbk95NT7IvYZlWVr0',
                            type: 'xyz',
                            visible: false,
                            index: 996,
                            layerOptions: {
                                attribution: "&copy; 2021 TomTom",
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 9,
                                opacity: 0.5
                            }
                        },

                        // Ticari grubu (index: 700-799)
                        street: {
                            name: $translate.instant('c_map22'),
                            type: 'group',
                            visible: false,
                            index: 706,
                            layerOptions: {
                                maxZoom: 22,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },
                        tpi: {
                            name: $translate.instant('c_map31'),
                            type: 'group',
                            visible: false,
                            index: 705,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },
                        commercialRentStore: {
                            name: $translate.instant('c_map23'),
                            type: 'group',
                            visible: false,
                            index: 704,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },
                        commercialPriceStore: {
                            name: $translate.instant('c_map24'),
                            type: 'group',
                            visible: false,
                            index: 703,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },
                        commercialRentOffice: {
                            name: $translate.instant('c_map25'),
                            type: 'group',
                            visible: false,
                            index: 702,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },
                        commercialPriceOffice: {
                            name: $translate.instant('c_map26'),
                            type: 'group',
                            visible: false,
                            index: 701,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },

                        // Konut grubu (index: 500-599)
                        salesCount: {
                            name: $translate.instant('c_map32'),
                            type: 'group',
                            visible: false,
                            index: 507,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propSalePrice: {
                            name: $translate.instant('c_map27'),
                            type: 'group',
                            visible: false,
                            index: 506,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propRentPrice: {
                            name: $translate.instant('c_map28'),
                            type: 'group',
                            visible: false,
                            index: 505,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propRoom: {
                            name: $translate.instant('c_map17'),
                            type: 'group',
                            visible: false,
                            index: 504,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propArea: {
                            name: $translate.instant('c_map16'),
                            type: 'group',
                            visible: false,
                            index: 503,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propFloor: {
                            name: $translate.instant('c_map18'),
                            type: 'group',
                            visible: false,
                            index: 502,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propAge: {
                            name: $translate.instant('c_map19'),
                            type: 'group',
                            visible: false,
                            index: 501,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },

                        // Diğer grubu (index: 100-199) - en altta (WMS'den sonra)
                        // malls: {
                        //     name: $translate.instant('c_map20'),
                        //     type: 'markercluster',
                        //     visible: false,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     },
                        //     group: $translate.instant('c_map12')
                        // },
                        // projects: {
                        //     name: $translate.instant('c_map21'),
                        //     type: 'markercluster',
                        //     visible: false,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     },
                        //     group: $translate.instant('c_map12')
                        // },
                        opportunities: {
                            name: $translate.instant('c_map10'),
                            type: 'markercluster',
                            visible: true,
                            index: 103,
                            layerOptions: {
                                showCoverageOnHover: false
                            },
                            group: $translate.instant('c_map12')
                        },
                        agents: {
                            name: $translate.instant('c_map9'),
                            type: 'markercluster',
                            visible: false,
                            index: 102,
                            layerOptions: {
                                showCoverageOnHover: false
                            },
                            group: $translate.instant('c_map12')
                        },
                        portfolio: {
                            name: $translate.instant('c_map11'),
                            type: 'markercluster',
                            visible: true,
                            index: 101,
                            layerOptions: {
                                showCoverageOnHover: false
                            },
                            group: $translate.instant('c_map12')
                        },
                        isochrone: {
                            name: 'Isochrone',
                            type: 'group',
                            visible: false,
                            index: 995,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        },
                        // megaProjects: {
                        //     name: window.lang === 'tr' ? 'Mega Projeler' : 'Mega Projects',
                        //     type: 'group',
                        //     visible: false,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     },
                        //     group: $translate.instant('c_map12')
                        // }
                    }
                }
            };
        };

        function getOptionsAgent() {
            return {
                defaults: {
                    zoomControlPosition: 'bottomleft',
                    attributionControl: true,
                    zoom: 9
                },
                detaillayers: {
                    baselayers: {
                        google: {
                            name: 'Google',
                            url: 'https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',

                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map29'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        mapbox_dark: {
                            name: $translate.instant('c_map6'),
                            type: 'xyz',
                            visible: true,
                            url: 'https://api.mapbox.com/styles/v1/mapbox/dark-v10/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3
                            },
                            group: $translate.instant('c_map5')
                        }
                    },
                    overlays: {
                        places: {
                            name: 'POI',
                            type: 'group',
                            visible: true,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,

                            }
                        }
                    }
                }
            };
        }

        function getOptionsQuake() {
            return {
                defaults: {
                    zoomControlPosition: 'topleft',
                    attributionControl: true,
                    zoom: 9
                },
                layercontrol: {
                    order: false,
                    // icons: {
                    //     uncheck: "fa ei-toggle-off",
                    //     check: "fa ei-toggle-on"
                    // }
                },
                detaillayers: {
                    baselayers: {
                        google: {
                            name: 'Google',
                            url: 'https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map29'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        google_satellite: {
                            name: $translate.instant('c_map1'),
                            url: 'https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map34'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true
                            },
                            group: $translate.instant('c_map4')
                        },
                        mapbox_satellite: {
                            name: $translate.instant('c_map3'),
                            url: 'https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3
                            }
                        },
                        mapbox: {
                            name: $translate.instant('c_map2'),
                            type: 'xyz',
                            url: 'https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,

                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        mapbox_terrain: {
                            name: $translate.instant('c_map15'),
                            type: 'xyz',
                            url: 'https://api.mapbox.com/styles/v1/mapbox/outdoors-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,

                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        mapbox_dark: {
                            name: $translate.instant('c_map6'),
                            type: 'xyz',
                            visible: true,
                            url: 'https://api.mapbox.com/styles/v1/mapbox/dark-v10/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3
                            },
                            group: $translate.instant('c_map5')
                        }
                    },
                    overlays: {
                        quakes: {
                            name: $translate.instant('c_map8'),
                            type: 'markercluster',
                            visible: true,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        },
                        heatmap: {
                            name: $translate.instant('c_map7'),
                            type: 'group',
                            visible: true,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                maxZoom: 22,
                                minZoom: 9,
                                showOnSelector: false
                            }
                        }
                    }
                }
            };
        }

        function getOptionsWidget() {
            return {
                defaults: {
                    zoomControlPosition: 'topleft',
                    attributionControl: true,
                    zoom: 9
                },
                layercontrol: {
                    order: false,
                    // icons: {
                    //     uncheck: "fa ei-toggle-off",
                    //     check: "fa ei-toggle-on"
                    // }
                },
                detaillayers: {
                    baselayers: {
                        google: {
                            name: 'Google',
                            url: 'https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map29'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        }
                        // mapbox: {
                        //     name: $translate.instant('c_map2'),
                        //     type: 'xyz',
                        //     url: 'https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                        //     layerOptions: {
                        //         attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                        //         continuousWorld: true,
                        //         maxZoom: 22,
                        //         minZoom: 3
                        //     },
                        //     group: $translate.instant('c_map5')
                        // }
                    },
                    overlays: {
                        places: {
                            name: 'POI',
                            type: 'group',
                            visible: true,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,

                            }
                        },
                        heatmap: {
                            name: $translate.instant('c_map7'),
                            type: 'group',
                            visible: true,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                maxZoom: 22,
                                minZoom: 9,
                                showOnSelector: false
                            }
                        },
                        quakes: {
                            name: $translate.instant('c_map8'),
                            type: 'markercluster',
                            visible: true,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        }
                    }
                }
            };
        }

        function getOptionsLocation() {
            return {
                defaults: {
                    zoomControlPosition: 'topleft',
                    attributionControl: true,
                    zoom: 9
                },
                layercontrol: {
                    order: false,
                    // icons: {
                    //     uncheck: "fa ei-toggle-off",
                    //     check: "fa ei-toggle-on"
                    // }
                },
                detaillayers: {
                    baselayers: {
                        google: {
                            name: 'Google',
                            url: 'https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map29'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        google_satellite: {
                            name: $translate.instant('c_map1'),
                            url: 'https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map34'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true
                            },
                            group: $translate.instant('c_map4')
                        },
                        mapbox_satellite: {
                            name: $translate.instant('c_map3'),
                            url: 'https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3
                            }
                        },
                        mapbox: {
                            name: $translate.instant('c_map2'),
                            type: 'xyz',
                            url: 'https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,

                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        mapbox_terrain: {
                            name: $translate.instant('c_map15'),
                            type: 'xyz',
                            url: 'https://api.mapbox.com/styles/v1/mapbox/outdoors-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,

                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        mapbox_dark: {
                            name: $translate.instant('c_map6'),
                            type: 'xyz',
                            visible: true,
                            url: 'https://api.mapbox.com/styles/v1/mapbox/dark-v10/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3
                            },
                            group: $translate.instant('c_map5')
                        }
                    },
                    overlays: {
                        // Descending sort: higher index = appears first (top)
                        // Order: Ungrouped (900+) → Ticari (700s) → Konut (500s) → WMS (200s) → Diğer (100s)

                        // Grupsuz layer'lar (index: 900+) - en üstte
                        locations: {
                            name: $translate.instant('c_map36'),
                            type: 'markercluster',
                            visible: false,
                            index: 999,
                            layerOptions: {
                                continuousWorld: true,

                            }
                        },
                        sales: {
                            name: $translate.instant('c_map37'),
                            type: 'markercluster',
                            visible: false,
                            index: 998,
                            layerOptions: {
                                continuousWorld: true,

                            }
                        },
                        isochrone: {
                            name: 'Isochrone',
                            type: 'group',
                            visible: false,
                            index: 997,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        },
                        voronoi: {
                            name: 'Voronoi',
                            type: 'group',
                            visible: false,
                            index: 996,
                            layerOptions: {
                                showCoverageOnHover: false,

                            }
                        },
                        places: {
                            name: 'POI',
                            type: 'markerscanvas',
                            visible: true,
                            index: 995,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,

                            }
                        },
                        draw: {
                            name: $translate.instant('c_map35'),
                            type: 'group',
                            visible: true,
                            index: 994,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        },
                        heatmap: {
                            name: $translate.instant('c_map7'),
                            type: 'group',
                            visible: true,
                            index: 993,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                maxZoom: 22,
                                minZoom: 9
                            }
                        },

                        traffic: {
                            name: $translate.instant('c_map30'),
                            url: 'https://api.tomtom.com/traffic/map/4/tile/flow/absolute/{z}/{x}/{y}.png?key=xHAk40RiUkJsPXwXbk95NT7IvYZlWVr0',
                            type: 'xyz',
                            visible: false,
                            index: 992,
                            layerOptions: {
                                attribution: "&copy; 2021 TomTom",
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 9,
                                opacity: 0.5
                            }
                        },

                        // Ticari grubu (index: 700-799)
                        street: {
                            name: $translate.instant('c_map22'),
                            type: 'group',
                            visible: false,
                            index: 706,
                            layerOptions: {
                                maxZoom: 22,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },
                        tpi: {
                            name: $translate.instant('c_map31'),
                            type: 'group',
                            visible: false,
                            index: 705,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },
                        commercialRentStore: {
                            name: $translate.instant('c_map23'),
                            type: 'group',
                            visible: false,
                            index: 704,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },
                        commercialPriceStore: {
                            name: $translate.instant('c_map24'),
                            type: 'group',
                            visible: false,
                            index: 703,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },
                        commercialRentOffice: {
                            name: $translate.instant('c_map25'),
                            type: 'group',
                            visible: false,
                            index: 702,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },
                        commercialPriceOffice: {
                            name: $translate.instant('c_map26'),
                            type: 'group',
                            visible: false,
                            index: 701,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },

                        // Konut grubu (index: 500-599)
                        salesCount: {
                            name: $translate.instant('c_map32'),
                            type: 'group',
                            visible: false,
                            index: 507,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propSalePrice: {
                            name: $translate.instant('c_map27'),
                            type: 'group',
                            visible: false,
                            index: 506,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propRentPrice: {
                            name: $translate.instant('c_map28'),
                            type: 'group',
                            visible: false,
                            index: 505,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propRoom: {
                            name: $translate.instant('c_map17'),
                            type: 'group',
                            visible: false,
                            index: 504,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propArea: {
                            name: $translate.instant('c_map16'),
                            type: 'group',
                            visible: false,
                            index: 503,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propFloor: {
                            name: $translate.instant('c_map18'),
                            type: 'group',
                            visible: false,
                            index: 502,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propAge: {
                            name: $translate.instant('c_map19'),
                            type: 'group',
                            visible: false,
                            index: 501,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },

                        // Diğer grubu (index: 100-199) - en altta (WMS'den sonra)
                        // malls: {
                        //     name: $translate.instant('c_map20'),
                        //     type: 'markercluster',
                        //     visible: false,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     },
                        //     group: $translate.instant('c_map12')
                        // },
                        // projects: {
                        //     name: $translate.instant('c_map21'),
                        //     type: 'markercluster',
                        //     visible: false,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     },
                        //     group: $translate.instant('c_map12')
                        // },
                        opportunities: {
                            name: $translate.instant('c_map10'),
                            index: 103,
                            type: 'markercluster',
                            visible: false,
                            layerOptions: {
                                showCoverageOnHover: false
                            },
                            group: $translate.instant('c_map12')
                        },
                        agents: {
                            name: $translate.instant('c_map9'),
                            type: 'markercluster',
                            visible: false,
                            index: 102,
                            layerOptions: {
                                showCoverageOnHover: false
                            },
                            group: $translate.instant('c_map12')
                        },
                        portfolio: {
                            name: $translate.instant('c_map11'),
                            type: 'markercluster',
                            visible: true,
                            index: 101,
                            layerOptions: {
                                showCoverageOnHover: false
                            },
                            group: $translate.instant('c_map12')
                        },
                        // megaProjects: {
                        //     name: window.lang === 'tr' ? 'Mega Projeler' : 'Mega Projects',
                        //     type: 'group',
                        //     visible: false,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     },
                        //     group: $translate.instant('c_map12')
                        // }
                    }
                }
            };
        }

        function getMarker(lat, lng, message) {


            if (message && !isMobile())
                return {
                    m1: {
                        //layer: 'places',
                        lat: lat,
                        lng: lng,
                        message: message,
                        focus: true,
                        opacity: 1,
                        draggable: false,
                        zIndexOffset: -1,
                        icon: {
                            type: 'awesomeMarker',
                            prefix: 'ei',
                            icon: 'endeksa',
                            markerColor: "red",
                            iconColor: "#fff"
                        },
                        properties: {
                            distance: 0,
                            key: 'm1'
                        }
                    }
                };
            else
                return {
                    m1: {
                        lat: lat,
                        lng: lng,
                        focus: true,
                        opacity: 1,
                        draggable: false,
                        zIndexOffset: -1,
                        icon: {
                            type: 'awesomeMarker',
                            prefix: 'ei',
                            icon: 'endeksa',
                            markerColor: "red",
                            iconColor: "#fff"
                        },
                        properties: {
                            distance: 0,
                            key: 'm1'
                        }
                    }
                };
        }

        function drawControl() {
            return {
                //position: 'topleft',
                //edit: {
                //    featureGroup: obj.drawLayer,
                //},
                draw: {
                    polyline: {
                        //guideLayers: [obj.drawLayer, obj.tempLayer],
                        allowIntersection: false,
                        shapeOptions: {
                            color: '#FF0550',
                            clickable: false
                        },
                        metric: true,
                        feet: false,
                        nautic: false
                    },
                    polygon: {
                        //guideLayers: [obj.drawLayer, obj.tempLayer],
                        allowIntersection: false,
                        shapeOptions: {
                            color: '#FF0550',
                            clickable: false
                        },
                        metric: true,
                        feet: false,
                        nautic: false
                    },
                    circle: {
                        //guideLayers: [obj.drawLayer, obj.tempLayer],
                        allowIntersection: false,
                        shapeOptions: {
                            color: '#FF0550',
                            clickable: false
                        },
                        metric: true,
                        feet: false,
                        nautic: false
                    },
                    //rectangle: {
                    //    //guideLayers: [obj.drawLayer, obj.tempLayer],
                    //    allowIntersection: false,
                    //    shapeOptions: {
                    //        color: '#FF0550',
                    //        clickable: false
                    //    },
                    //    metric: true,
                    //    feet: false,
                    //    nautic: false
                    //},
                    rectangle: false,
                    marker: false,
                    circlemarker: false
                }
            };
        }

        function getMapOptionsNeighbors() {
            return {
                defaults: {
                    zoomControlPosition: 'bottomleft',
                    attributionControl: true
                },
                detaillayers: {
                    baselayers: {
                        google: {
                            name: 'Google',
                            url: 'https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',

                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map29'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        }
                        // mapbox: {
                        //     name: $translate.instant('c_map2'),
                        //     type: 'xyz',
                        //     url: 'https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                        //     layerOptions: {
                        //         attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                        //         continuousWorld: true,
                        //         maxZoom: 22,
                        //         minZoom: 3
                        //     },
                        //     group: $translate.instant('c_map5')
                        // }
                    },
                    overlays: {
                        places: {
                            name: 'İmleçler',
                            type: 'group',
                            visible: true,
                            layerOptions: {
                                continuousWorld: true,

                            }
                        }
                    }
                }
            };
        }

    }
})();
